/**
 * Created by ferasmasood on 8/14/17.
 */
(function () {

    "use strict";

    var app = angular.module('harriApp');

    app.directive('globalSearchResults', ['$state', 'hUser', function ($state, hUser) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: "../scripts/global-directives/global_search_result_directive/global_search_result.html",
            scope: {
                results: '=',
                limit: '=',
                hits: '=',
                searchPhrase: '=',
                callbacks: '=',
                error: '=',
                loading: '=',
            },
            link: function (scope, element, attrs) {
                if (!scope.limit) {
                    scope.limit = GlobalSearchAPI.RECORDS_LIMIT;
                }
                scope.hitsArray = [];
                scope.loadersArr = _.range(0, scope.limit);

                scope.isHMAPContext = hUser.getUserContext().brand_type.indexOf('GP') > -1;

                var i = 0;
                while (i * GlobalSearchAPI.RECORDS_LIMIT <= scope.hits) {
                    scope.hitsArray.push(++i);
                }
                if (scope.callbacks && _.isEmpty(scope.callbacks)) {
                    scope.callbacks = {
                        setHits: function (hits) {
                            scope.hits = hits;
                            scope.hitsArray = [];
                            var i = 0;
                            while (i * GlobalSearchAPI.RECORDS_LIMIT <= scope.hits) {
                                scope.hitsArray.push(++i);
                            }
                        }
                    }
                }
                scope.currentPage = 1;
                var lastResolved = 0;
                scope.goToPage = function (i) {
                    scope.currentPage = i;
                    i -= 1;
                    GlobalSearchDataManager.getSearchResult(hUser, scope.searchPhrase, i * GlobalSearchAPI.RECORDS_LIMIT, GlobalSearchAPI.RECORDS_LIMIT).then(function (res) {
                        scope.hits = res.hits;
                        scope.results = res.results;
                        if (scope.error) {
                            delete scope.error;
                        }
                        scope.$digest();
                    }, function (err) {
                        scope.results = [];
                        scope.hits = 0;
                        scope.error = true;
                        scope.$digest();
                    })
                };
                scope.detectResultType = function (type) {
                    var searchTypes;
                    scope.type = type;
                    if (type) {
                        if (type === "EMPLOYEE") {
                            searchTypes = ['TEAM_LIVE_EMPLOYEE', 'ONBOARDING_EMPLOYEE'];
                        } else {
                            searchTypes = [type];
                        }
                    }
                    scope.loading = true;
                    GlobalSearchDataManager.getSearchResult(hUser, scope.searchPhrase, 0, GlobalSearchAPI.RECORDS_LIMIT, searchTypes).then(function (res) {
                        scope.hits = res.hits;
                        scope.results = res.results;
                        if (scope.error) {
                            delete scope.error;
                        }
                    }).catch(function (err) {
                        console.error(err);
                        scope.results = [];
                        scope.hits = 0;
                        scope.error = true;
                    })
                     .finally(function () {
                            scope.loading = false;
                            scope.$digest();
                        });

                };

                scope.resultClicked = function (entry, $event) {
                    if (scope.isHMAPContext) {
                        var userContextChangePromise;

                         if (entry.type == GlobalSearchAPI.RESULT_TEAM_LIVE_EMPLOYEE) {
                            userContextChangePromise = hUser.setUserContext({
                                brand_id: entry.primaryLocation.group_id
                            });
                        }
                        else if (entry.type == GlobalSearchAPI.RESULT_TYPE_APPLICANT) {

                            var brandId = entry.details.brand.type === "enterprise" ? entry.details.brand.id : entry.details.brand.group_id;

                            userContextChangePromise = hUser.setUserContext({
                                brand_id: brandId,
                                brand_type: entry.details.brand.type
                            });
                        }

                        if (userContextChangePromise) {
                            $event.preventDefault();

                            userContextChangePromise.then(function () {
                                scope.callbacks.hideSearchPreview?.();
                                $state.go(entry.stateName, entry.stateParams, {reload: true});
                            });
                        } else {
                            scope.callbacks.hideSearchPreview && scope.callbacks.hideSearchPreview();
                        }

                    } else {
                        scope.callbacks.hideSearchPreview && scope.callbacks.hideSearchPreview();
                    }
                };

                var capitalizeString = function (string) {
                    var stringWords = string.split(" ");
                    for (var wordIndex in stringWords) {
                        if (stringWords[wordIndex].length > 0) {
                            if (stringWords[wordIndex].indexOf('<b>') !== 0) {
                                stringWords[wordIndex] = stringWords[wordIndex][0].toUpperCase() + stringWords[wordIndex].substr(1, stringWords[wordIndex].length - 1)
                            } else {
                                stringWords[wordIndex] = stringWords[wordIndex].substr(0, 3) + stringWords[wordIndex][3].toUpperCase() + stringWords[wordIndex].substr(4, stringWords[wordIndex].length - 1)
                            }
                        }
                    }
                    return stringWords.join(" ")
                }


            }
        }
    }]);
})();


